<template>
  <v-btn
    v-show="show"
    class="mx-2"
    small
    color="transparent"
    elevation="2"
    @click="$emit('reset')"
    >{{ text }}</v-btn
  >
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      default: "Reset Filters"
    }
  }
};
</script>
